import type { QuerySitesRequest } from "@wix/ambassador-site-list-v2-site/build/cjs/types.impl";
import type { PanoramaClient } from "@wix/panorama-client";
import { useHttpClient, usePanorama } from "@wix/fe-essentials-standalone";
import { getUserPicassoSites } from "./api";
import { useInfiniteQuery } from "react-query";

const SITES_QUERY_KEY = "query-sites";

export const useQuerySites = (
  enabled: boolean,
  baseOptions: QuerySitesRequest,
) => {
  const httpClient = useHttpClient();
  const panoramaClient: PanoramaClient = usePanorama();

  return useInfiniteQuery({
    queryKey: [SITES_QUERY_KEY],
    queryFn: ({ pageParam }) =>
      getUserPicassoSites({
        httpClient,
        options: {
          ...baseOptions,
          query: {
            ...baseOptions.query,
            cursorPaging: {
              limit: baseOptions.query?.cursorPaging?.limit ?? 8,
              cursor: pageParam,
            },
          },
        },
        panoramaClient,
      }),
    getNextPageParam: (lastPage) => lastPage.metadata?.cursors?.next,
    enabled,
  });
};
